module.exports = __webpack_public_path__ + "static/media/customer-lovely-bake.dfebb460.png";